import { Component, Input, OnInit } from '@angular/core'
import { NotificationService } from '../../../../../providers/notification/notification.service';
import { PropertySearcher } from '../../../custom-views/helpers/property-searcher.helper';

@Component({
  selector: 'app-quote-column',
  templateUrl: './quote-column.component.html',
  styleUrls: ['./quote-column.component.scss'],
})
export class QuoteColumnComponent implements OnInit {
  @Input() data: unknown;
  isHighlighted: boolean;

  constructor(private readonly notificationService: NotificationService) {
  }

  ngOnInit() {
    const notificationDictionary = PropertySearcher.findValue(this.data, 'notificationDictionary');
    const quoteCreated = notificationDictionary && notificationDictionary.quoteCreated || undefined;
    this.isHighlighted = !!quoteCreated;

    if (quoteCreated) {
      this.notificationService.markAsViewed(quoteCreated.id).subscribe();
    }
  }
}
